import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Facebook, Instagram, MessageCircle, ArrowUpRight } from "lucide-react";
import { siteInfo, categories } from "../data/mock";

const Footer = () => {
  return (
    <footer className="bg-brand-dark text-white/90 pt-20 pb-8 mt-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div>
            <div className="mb-5 bg-white rounded-2xl p-3 inline-block">
              <img src="/logo-apf.png" alt="Associazione Progetto Futuro" className="h-14 object-contain" />
            </div>
            <p className="text-sm text-emerald-100/70 leading-relaxed mb-6">
              {siteInfo.tagline} Costruiamo insieme il tuo percorso professionale con corsi qualificati e riconosciuti.
            </p>
            <div className="flex gap-3">
              <a href={siteInfo.socials.facebook} className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center" aria-label="Facebook">
                <Facebook className="w-4 h-4" />
              </a>
              <a href={siteInfo.socials.instagram} className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center" aria-label="Instagram">
                <Instagram className="w-4 h-4" />
              </a>
              <a href={siteInfo.socials.whatsapp} className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center" aria-label="WhatsApp">
                <MessageCircle className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display text-lg font-bold text-white mb-5">Categorie</h4>
            <ul className="space-y-3">
              {categories.slice(0, 5).map((c) => (
                <li key={c.id}>
                  <a href="#categorie" className="text-sm text-emerald-100/70 hover:text-white flex items-center gap-1.5 group">
                    <span>{c.title}</span>
                    <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg font-bold text-white mb-5">Link Utili</h4>
            <ul className="space-y-3 text-sm text-emerald-100/70">
              <li><Link to="/chi-siamo" className="hover:text-white">Chi Siamo</Link></li>
              <li><Link to="/#corsi" className="hover:text-white">I Nostri Corsi</Link></li>
              <li><Link to="/richiedi-info" className="hover:text-white">Richiedi Informazioni</Link></li>
              <li><Link to="/contatti" className="hover:text-white">Contatti</Link></li>
              <li><a href="#" className="hover:text-white">Privacy & Cookie</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg font-bold text-white mb-5">Contatti</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-emerald-300" />
                <span className="text-emerald-100/70">{siteInfo.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0 text-emerald-300" />
                <a href={`tel:${siteInfo.phone}`} className="text-emerald-100/70 hover:text-white">{siteInfo.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0 text-emerald-300" />
                <a href={`mailto:${siteInfo.email}`} className="text-emerald-100/70 hover:text-white break-all">{siteInfo.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-emerald-100/60">© {new Date().getFullYear()} Associazione Progetto Futuro. Tutti i diritti riservati.</p>
          <p className="text-xs text-emerald-100/60">Corsi di formazione professionale accreditati</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
